import React from "react";
import AdSenseUnit from "@/components/ads/AdSenseUnit";
import { AD_SLOTS } from "@/config/adSlots";
import { AD_LABEL } from "@/lib/adsensePolicy";

export default function ArticleSidebarAd() {
  return (
    <aside aria-label={`${AD_LABEL} 160 by 600`} className="hidden lg:flex justify-center rounded-[1.5rem] border border-[#BFDADC] bg-white/92 p-4 shadow-[0_14px_35px_rgba(8,22,51,0.08)]">
      <div className="w-[160px]">
        <div className="mb-2 text-center text-[11px] uppercase tracking-wide text-muted-foreground/70">{AD_LABEL}</div>
        <AdSenseUnit
          slot={AD_SLOTS.display}
          format="auto"
          responsive={false}
          style={{ display: "block", width: 160, height: 600, minHeight: 600 }}
        />
      </div>
    </aside>
  );
}